// extracted by mini-css-extract-plugin
module.exports = {"error_container":"U_M_5zk","error_header":"KAEkc2K","error_header_text":"_2xAPyKm","error_body":"_3pvo8B-","error_body_details":"ITCQQzU"};